import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import GitchaLogo from "@/images/gitcha-logo.svg";
import { longDay } from "./proUpgradeModel";
import { pendingRequest, useMyProRequest, useSendProRequest } from "./useProRequest";

export const NOTE_LIMIT = 500;

export const AskBrokerLine = ({ brokerageName, onAsk, enabled = true }) => {
  const mine = useMyProRequest(enabled);
  const pending = pendingRequest(mine.data);
  if (pending) {
    return (
      <p className="pro-upgrade__ask">
        Asked {brokerageName} on {longDay(pending.createdAt)}
      </p>
    );
  }
  return (
    <p className="pro-upgrade__ask">
      Does {brokerageName} cover Pro?{" "}
      <button type="button" className="pro-upgrade__ask-link" onClick={onAsk}>
        Ask your broker
      </button>
    </p>
  );
};

const AskBroker = ({ show, onHide, brokerageName }) => {
  const [note, setNote] = useState("");
  const [sent, setSent] = useState(null);
  const send = useSendProRequest({ onSuccess: (request) => setSent(request || { createdAt: new Date().toISOString() }) });

  const close = () => {
    setNote("");
    setSent(null);
    send.reset();
    onHide();
  };

  return (
    <Modal show={show} onHide={close} centered className="pro-ask-modal" aria-labelledby="pro-ask-title">
      <Modal.Body>
        <button type="button" className="btn-close" aria-label="Close" onClick={close} />
        <img src={GitchaLogo} alt="Gitcha" className="pro-ask__logo" />
        {sent ? (
          <>
            <h2 id="pro-ask-title" className="pro-ask__title">
              Request sent
            </h2>
            <p className="pro-ask__line">
              Sent to {brokerageName} on {longDay(sent.createdAt || new Date())}. You'll get an email when they answer.
            </p>
            <button type="button" className="btn btn-primary pro-ask__button" onClick={close}>
              Done
            </button>
          </>
        ) : (
          <>
            <h2 id="pro-ask-title" className="pro-ask__title">
              Ask {brokerageName} to cover Gitcha&nbsp;Pro
            </h2>
            <p className="pro-ask__line">Your broker sees your request in Settings and can add you to their brokerage plan.</p>
            <label className="pro-ask__label" htmlFor="pro-ask-note">
              Note to your broker (optional)
            </label>
            <textarea
              id="pro-ask-note"
              className="pro-ask__note"
              value={note}
              maxLength={NOTE_LIMIT}
              rows={3}
              onChange={(event) => setNote(event.target.value)}
            />
            {send.error ? (
              <p className="pro-ask__error" role="alert">
                {send.error.message}
              </p>
            ) : null}
            <button
              type="button"
              className="btn btn-primary pro-ask__button"
              disabled={send.isPending}
              onClick={() => send.mutate(note.trim())}
            >
              {send.isPending ? "Sending" : "Send request"}
            </button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AskBroker;
